import { Injectable } from '@angular/core';
import { AbstractDataProvider } from '../../app/AbstractDataProvider';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class LoginProvider {

  login$ = new Subject();

  constructor(private abstractDataProvider: AbstractDataProvider) {
  }

  login(userProfile: any) {
    return this.abstractDataProvider.postData(userProfile, 'api/Login/CheckLogin');
  }

  loginToken(userProfile: any, twoFaRememberToken: string = null) {
    return this.abstractDataProvider.postData(
      'userName=' + encodeURIComponent(userProfile.username) +
      '&password=' + encodeURIComponent(userProfile.password) +
      '&grant_type=password' +
      '&two_fa_remember_token=' + encodeURIComponent(twoFaRememberToken ?? '')
      ,

      'token'
    ).pipe(tap(() => this.login$.next()));
  }

  loginToken2fa(userProfile: any, code: string, rememeber2fa: boolean) {
    return this.abstractDataProvider
      .postData(

        'userName=' + encodeURIComponent(userProfile.username) +
        '&password=' + encodeURIComponent(userProfile.password) +
        '&grant_type=password' +
        '&twoFaCode=' + encodeURIComponent(code) +
        '&remember2fa=' + rememeber2fa
        ,

        'token'
      ).pipe(tap(() => this.login$.next()));
  }

  logout() {
    return this.abstractDataProvider.getData('api/Login/Logout');
  }

  getMenuListForLoggedInUser() {
    return this.abstractDataProvider.getData('api/Menu/GetAllMenus');
  }

  checkClientDatabaseStatus() {
    return this.abstractDataProvider.getData('api/Configuration/CheckClientDatabaseStatus');
  }

  getApplicationVersion() {
    return this.abstractDataProvider.getData('api/Menu/GetApplicationVersion');
  }

  getData(url) {
    return this.abstractDataProvider.getData(url);
  }

  updateLoginInfo(status) {
    return this.abstractDataProvider.postData({status: status}, 'api/Login/UpdateLoginInfo');
  }

}
